import {
  getFilteredStops,
  getStopFilters,
  getSortedStops,
} from '../../../selectors/ui/routeDetail';
import {
  getNewSelectedStopNumbers,
  getNextSelectedByFilterStops,
  getSatisfyCriteriaStopIds,
  getStopsToSelect,
} from '../../../../models/routeDetail';
import { getNextRouteFilters } from '../../../../features/routeDetail/model';
import { getRouteDetail } from '../../../selectors/route';
import { removeCriteriaById } from '../../../../features/routeDetail/criteriaModel';
import {
  setPreviousStopIndex,
  updateFilters,
  updateSelectedStops,
  clearSelection,
  setCriteriaValue,
} from '../../../reducers/ui/routeDetail/stopFilters';
import { setDefaultOrder } from '../../../reducers/ui/routeDetail/stopListOrder';
import { resetSelectedParcels } from '../../../reducers/ui/routeDetail/selectedParcels';

export const clearSelectedResetOrder = () => (dispatch) => {
  dispatch(clearSelection());
  dispatch(setDefaultOrder());
  dispatch(resetSelectedParcels());
};

export const toggleFilter = (id) => (dispatch, getState) => {
  const state = getState();
  const { filters } = getStopFilters(state);
  const { stop: stops } = getRouteDetail(state);

  const nextFilters = getNextRouteFilters(filters, id);
  const selectedStopIds = getNextSelectedByFilterStops(nextFilters, stops);

  dispatch(updateFilters({ filters: nextFilters, stopIds: selectedStopIds }));
};

export const toggleSelectedStop =
  (stop, stopIndex, shiftKey) => (dispatch, getState) => {
    const state = getState();
    const { previousStopIndex, filters, manuallySelectedStops, criteria } =
      getStopFilters(state);
    const filteredStops = getFilteredStops(state);
    const sortedStops = getSortedStops(state);

    if (!stop || !+stop.stopNumber) {
      return dispatch(setPreviousStopIndex(null));
    }

    const stopsToSelect = getStopsToSelect({
      stopId: stop.stopId,
      stops: sortedStops,
      previousStopIndex,
      stopIndex,
      shiftKey,
    });

    const isFilter = !!filters.length;

    const newSelectedStops = getNewSelectedStopNumbers({
      stops: filteredStops,
      selectedStops: manuallySelectedStops,
      stopsToSelect,
      isFilter,
    });

    if (isFilter || criteria.length) {
      dispatch(clearSelection());
    }
    dispatch(setPreviousStopIndex(stopIndex));
    dispatch(updateSelectedStops(newSelectedStops));
  };

export const setCriteria = (criteria) => (dispatch, getState) => {
  const { stop: stops } = getRouteDetail(getState());
  const selectedStopIds = criteria.length
    ? getSatisfyCriteriaStopIds(criteria, stops)
    : [];
  dispatch(setCriteriaValue({ criteria, selectedStopIds }));
};

export const removeCriteria = (id) => (dispatch, getState) => {
  const { criteria } = getStopFilters(getState());
  const nextCriteria = removeCriteriaById(criteria, id);
  dispatch(setCriteria(nextCriteria));
};
